import { ContractScreensViewOptimized } from './ContractScreensViewOptimized';

//TODO HANDLE ADD/REMOVE CYCLE SCREEN
export const ContractScreens = ContractScreensViewOptimized
